import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-arrow",
  "use": "icon-icon-arrow-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-icon-arrow\"><path d=\"M142.529,93.113c-0.296-0.296-0.608-0.567-0.928-0.822c-0.257-0.323-0.529-0.637-0.828-0.935L77.688,28.271\n\tC73.416,24,66.49,24,62.219,28.271c-4.27,4.271-4.27,11.197,0.002,15.469l57.106,57.106l-55.351,55.351\n\tc-4.271,4.271-4.271,11.197,0,15.469s11.197,4.271,15.469,0l63.084-63.082C146.801,104.312,146.801,97.387,142.529,93.113z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol